// import { useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../login/apilogin";// Make sure this points to your axios instance

// const AutoLogout = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     let timeout;

//     const logoutUser = async () => {
//       try {
//         // Call backend logout
//         await api.post("logout/");

//         // Clear local storage or any client-side auth data
//         localStorage.removeItem("user");

//         // Navigate to home or login page
//         navigate("/");
//         console.log("User logged out successfully");
//       } catch (err) {
//         console.error(
//           "Logout failed:",
//           err.response ? err.response.data : err
//         );
//       }
//     };

//     const resetTimer = () => {
//       clearTimeout(timeout);
//       // 20 minutes = 20 * 60 * 1000
//       timeout = setTimeout(logoutUser, 20 * 60 * 1000);
//       console.log("Timer reset");
//     };

//     const events = [
//       "mousemove",
//       "mousedown",
//       "keydown",
//       "touchstart",
//       "scroll",
//     ];

//     events.forEach((e) => window.addEventListener(e, resetTimer));

//     resetTimer();

//     return () => {
//       clearTimeout(timeout);
//       events.forEach((e) => window.removeEventListener(e, resetTimer));
//     };
//   }, [navigate]);

//   return null;
// };

// export default AutoLogout;


import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../login/apilogin";

const AutoLogout = () => {
  const navigate = useNavigate();

  // useRef prevents timeout reset on re-render
  const timeoutRef = useRef(null);

  useEffect(() => {

    // =========================
    // LOGOUT FUNCTION
    // =========================
    const logoutUser = async () => {
      try {

        console.log("Auto logout triggered");

        await api.post("logout/");

        localStorage.removeItem("user");

        navigate("/");

      } catch (err) {

        console.error(
          "Logout failed:",
          err.response ? err.response.data : err
        );

      }
    };

    // =========================
    // RESET TIMER
    // =========================
    const resetTimer = () => {

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // 20 minutes
      timeoutRef.current = setTimeout(() => {
        logoutUser();
      }, 20 * 60 * 1000);

      console.log("Timer Reset");
    };

    // =========================
    // EVENTS
    // =========================
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "touchstart",
      "scroll",
      "click"
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    // start timer
    resetTimer();

    // =========================
    // CLEANUP
    // =========================
    return () => {

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };

  }, [navigate]);

  return null;
};

export default AutoLogout;